import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { ActionsBlock } from "@/react/components/shared/BuilderUI/constants/BlockCategories";
import {
  ContentProp,
  DesignProp,
  MarginsProp,
} from "@/react/components/shared/BuilderUI/constants/PropCategories";

import { blockExists } from "../../blocks/shared/blockExists";
import { FormButtonBlock as Block } from "./FormButtonBlock";
import { defaultData } from "./FormButtonBlockDefaultData";

export const FormButtonBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-button",
    size: 24,
  },
  meta: {
    name: "Form Button",
    version: 1,
    nameI18n: "builder_ui.block_type.form_button",
    category: [ActionsBlock],
    isDisabled: blocks => blockExists(blocks, "FormButtonBlock"),
    props: {
      label: {
        prop: "other",
        type: "string",
        name: "Button Text",
        nameI18n: "builder_ui.prop_type.button_text",
        category: [ContentProp],
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        category: [DesignProp],
        prop: "styles",
        type: "styles",
        attributes: {
          margin: {
            prop: "style-attribute",
            name: "Margin",
            nameI18n: "builder_ui.prop_type.styles.margin",
            category: [DesignProp, MarginsProp],
            type: "box-model",
            boxModelType: "margin",
            defaultValue: {
              marginTop: "0",
              marginBottom: "0",
              marginLeft: "0",
              marginRight: "0",
            },
          },
        },
      },
    },
  },
};
